export const EVENT_NAME_MAX_LENGTH = 250;
export const EVENT_DESCRIPTION_MAX_LENGTH = 1500;
/** The smallest card charge ticketing accepts. */
export const MIN_TICKET_PRICE = 0.5;
export const MAX_TICKET_TIER_CAPACITY = 1000000;
export const TICKET_TIER_LABEL_MAX_LENGTH = 120;
/** A tier this close to selling out shows how many seats are left. */
export const TICKET_SEATS_LEFT_THRESHOLD = 5;
/** A tier whose sales close sooner than this says when they end. */
export const TICKET_SALES_ENDING_SOON_HOURS = 24;
/** Sales close choices, in hours after the start; the admin's latest close trims them and their default joins them. */
export const TICKET_SALES_CLOSE_HOURS = [0, 1, 2, 4, 8, 12, 24, 48, 72];
/** How often checkout asks whether the card charge settled, and for how long. */
export const TICKET_ORDER_POLL_INTERVAL_MS = 2000;
export const TICKET_ORDER_POLL_TIMEOUT_MS = 60000;

/** Resized poster variants: 1x and 2x of the hero's half-width column, and phone widths. */
export const TICKET_EVENT_POSTER_WIDTHS = [640, 960, 1280];
export const TICKET_EVENT_POSTER_SIZES = '(min-width: 1024px) 50vw, 100vw';
